import { render, staticRenderFns } from "./QAHelper.vue?vue&type=template&id=b612f2ec&scoped=true&"
import script from "./QAHelper.vue?vue&type=script&lang=js&"
export * from "./QAHelper.vue?vue&type=script&lang=js&"
import style0 from "./QAHelper.vue?vue&type=style&index=0&id=b612f2ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b612f2ec",
  null
  
)

export default component.exports